import MuiTab from '@mui/material/Tab';
import MuiTabs, { tabsClasses } from '@mui/material/Tabs';

import type { FunctionComponent, SyntheticEvent } from 'react';

export type RouteConfig = {
    readonly href: string;
    readonly label: string;
};

type NavigationProps = {
    readonly activeIndex: number | null;
    readonly onChange: (event: SyntheticEvent, newValue: number) => void;
    readonly routerConfig: ReadonlyArray<RouteConfig>;
};

export const Navigation: FunctionComponent<NavigationProps> = (props) => {
    const { activeIndex, onChange, routerConfig } = props;

    return (
        <MuiTabs
            component="nav"
            sx={{
                [`& .${tabsClasses.scroller}`]: { alignItems: 'stretch', display: 'flex' },
            }}
            TabIndicatorProps={{
                sx: {
                    height: '3px',
                },
            }}
            value={activeIndex ?? false}
            onChange={onChange}
        >
            {routerConfig.map(({ href, label }) => (
                <MuiTab
                    key={label}
                    aria-label={label}
                    href={href}
                    label={label}
                    sx={{
                        ['&.Mui-selected']: { color: 'text.primary' },
                        minWidth: 'auto',
                        px: 1,
                    }}
                />
            ))}
        </MuiTabs>
    );
};
